<template>
  <div class="vip-container">
    <download-top></download-top>
    <pay-loading
      :payLoading="payLoading"
      @close="payLoading = false"
    ></pay-loading>
    <div class="header-top">
      <div class="vip-card">
        <div class="header">
          <img v-if="userInfo && userInfo.avarUrl" :src="userInfo.avarUrl" />
          <img v-else src="../../assets/vip/user.png" />
        </div>
        <div class="user">
          <div class="name">
            <div>{{ userInfo ? userInfo.nickName : "未登录" }}</div>
            <img
              class="vip-icon"
              v-if="userInfo && userInfo.state === 1"
              src="../../assets/vip/viptag2.jpg"
            />
            <img
              class="vip-icon"
              v-if="userInfo && userInfo.state === 0"
              src="../../assets/vip/vippass.jpg"
            />
          </div>
          <div class="time">
            <div>{{ userInfo ? vipMemo : "登陆查看会员权益" }}</div>
            <van-button
              class="vip-action-tip"
              slot="button"
              size="mini"
              round
              :loading="actionLoading"
              @click="buyVipAction"
              >{{ vipActionText }}</van-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="pay-type">
      <van-grid :column-num="3" :border="false" :center="true" :gutter="10">
        <van-grid-item v-for="(item, index) in vipPrices" :key="index">
          <div
            :class="[
              buyType == index ? 'type-selected' : 'type-normal',
              'type-item',
            ]"
            @click="buyTypeChange(index)"
          >
            {{ item.Name }}
            <div class="item-price">
              <span>¥ </span
              >{{ item.IsBuyedThis ? item.Money : item.FirstMoney }}
            </div>
            <div class="item-old-price">¥ {{ item.VMoney }}</div>
            <div class="item-next-price">
              {{
                item.IsBuyedThis
                  ? "节省" + fixedMoney(item.VMoney - item.Money)
                  : "首月省" + fixedMoney(item.VMoney - item.FirstMoney)
              }}
            </div>
            <div class="item-tip">
              {{ item.Flag }}
            </div>
          </div>
        </van-grid-item>
      </van-grid>
    </div>

    <div v-if="userInfo">
      <div class="line"></div>
      <div>
        <van-cell
          class="coupon"
          title="优惠券"
          is-link
          :value="couponText"
          @click="showCouponSheetClick"
        />
      </div>
      <div class="line"></div>
    </div>

    <div class="intro">
      <div class="intro-title">
        错题集VIP会员特权
      </div>
      <img src="../../assets/vip/vip-infos.png" alt="" />

      <div v-if="!showMore" class="more" @click="showMore = true">
        查看更多<van-icon name="arrow-down"></van-icon>
      </div>

      <div v-if="showMore">
        <img src="../../assets/vip/vip-info1.png" />
        <img src="../../assets/vip/vip-info2.png" />
        <img src="../../assets/vip/vip-info3.png" />
        <img src="../../assets/vip/vip-info4.png" />
        <img src="../../assets/vip/vip-info5.png" />

        <div class="question">
          <h6>1.开通会员后是否能退款？</h6>
          <span
            >会员开通错题集会员后可享受对服务期限，一经开通将不予以退费，请仔细阅读后购买。</span
          >
        </div>
        <div class="question">
          <h6>2.错题集会员到期后是否能看内容？</h6>
          <span
            >购买错题集会员后，可查看绑定学生所有服务；服务到期后，需再次购买才能查看全部内容；未购买用户无法查看分析报告，但可以查看考试成绩、考试答题。</span
          >
        </div>

        <div class="protocol">
          <img src="../../assets/vip/cricle.png" alt="" />
          <a
            href="https://szone-activity.7net.cc/views/protocol/vip_services_agreement_new.html"
          >
            《错题集服务协议》
          </a>
        </div>
      </div>
    </div>

    <div class="line"></div>

    <div class="intro">
      <div class="intro-title">
        温馨提示
      </div>
      <div class="tip">
        <span
          >1.您将购买的商品为虚拟内容，购买后不可退款、转让、更换，请确认后购买</span
        >
        <span>2.您的购买记录可以在七天学堂APP“我的订单”中查看</span>
      </div>
    </div>

    <div class="line"></div>

    <div class="protos">
      <a
        href="https://szone-activity.7net.cc/views/protocol/tuifei_policy_new.html"
        class="protos-item"
        >《退费说明》</a
      >
    </div>

    <div class="line"></div>

    <div class="footer-height"></div>

    <div class="footer">
      <div class="left">
        <div class="price">
          总计 ¥{{ fixedMoney(totalMoney) }}
          <span>已优惠 ¥{{ fixedMoney(discountMoney) }}</span>
        </div>
        <div class="proto">
          开通即代表接受<a
            href="https://szone-activity.7net.cc/views/protocol/vip_services_agreement_new.html"
          >
            《错题集服务协议》
          </a>
        </div>
      </div>
      <div class="right">
        <van-button
          class="buy-btn"
          type="text"
          :loading="actionLoading"
          @click="buyVipAction"
          >{{ vipActionText }}</van-button
        >
      </div>
    </div>

    <van-action-sheet v-model="showCouponSheet" title="优惠券">
      <div class="sheet-content">
        <div
          class="coupon-item"
          v-for="(item, index) in couponList"
          :key="index"
          @click="useCouponClick(item)"
        >
          <div class="content">
            <div class="price" v-if="item.couponType === 1">
              <!-- 折扣券，取 discount -->
              {{
                item.discount === 0 ? "免单" : (item.discount * 10).toFixed(0)
              }}
              <span v-if="item.discount !== 0">折</span>
            </div>
            <div class="price" v-else>
              <!-- 代金券，取 money -->
              {{ item.money }}
              <span>元</span>
            </div>
            <div class="desc">
              <div class="name">{{ item.name }}</div>
              <div class="time">有效期至 {{ item.endTime }}</div>
            </div>
            <div
              class="selected"
              v-if="selectCoupon && selectCoupon.guid === item.guid"
            >
              <van-icon name="checked" color="#e85a57" size="20px" />
            </div>
          </div>
          <div class="tip">
            <van-icon
              name="warning"
              color="#aaa"
              @click.stop="showTipDialog(item)"
            ></van-icon>
            <label @click.stop="showTipDialog(item)">使用须知</label>
          </div>
        </div>
        <div
          v-if="couponList.length"
          class="dont-use"
          @click="dontUseCouponClick"
        >
          不使用优惠券
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import DownloadTop from "@/components/DownloadTop";
import Button from "vant/lib/button";
import "vant/lib/button/style";
import Dialog from "vant/lib/dialog";
import "vant/lib/dialog/style";
import Cell from "vant/lib/cell";
import "vant/lib/cell/style";
import Grid from "vant/lib/grid";
import "vant/lib/grid/style";
import GridItem from "vant/lib/grid-item";
import "vant/lib/grid-item/style";
import ActionSheet from "vant/lib/action-sheet";
import "vant/lib/action-sheet/style";
import Icon from "vant/lib/icon";
import "vant/lib/icon/style";

import OrderMixins from "@/mixins/order"; //订单相关公用方法

import { api_vipPriceList, api_getCouponList } from "@/api/vip.js";
import { $formatDate } from "@/common/common.js";

export default {
  name: "Vip",
  components: {
    DownloadTop,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [ActionSheet.name]: ActionSheet,
    [Icon.name]: Icon,
  },
  mixins: [OrderMixins],
  data() {
    return {
      vipActionText: "立即开通",
      vipMemo: "您还不是会员",
      actionLoading: false,
      vipPrices: [],
      buyType: 0,
      showMore: false,
      showCouponSheet: false,
      couponText: "",
      couponList: [],
      selectCoupon: "",
      totalMoney: "",
      discountMoney: "",
    };
  },
  watch: {
    payLoading: {
      deep: true,
      handler(newVal) {
        // 若为false则说明订单状态请求完成，此时更新用户信息
        if (!newVal)
          this.$store.dispatch("act_getuserInfo").then(() => {
            this.userInfo && this.getVipPrice() && this.getCouponList();
          });
      },
    },
  },
  computed: {
    userToken: {
      get() {
        return this.$store.state.token;
      },
    },
    userInfo: {
      get() {
        return this.$store.state.userInfo;
      },
    },
  },
  created() {
    this.$store.dispatch("share/initShareParams", {
      title: "错题集服务",
      desc: "学情分析、错题整理、一键下载，帮助孩子精准提分",
    });
    this.$track("start_vip");
  },
  mounted() {
    this.getVipPrice();
  },
  methods: {
    getVipPrice() {
      api_vipPriceList({
        source: 3,
      }).then((res) => {
        if (res.status === 200) {
          this.vipPrices = res.data.filter((item) => {
            return item.PriceType !== 3;
          });
          this.getDefaultBuyType();
          this.configVipText();
          this.getTotalMoney();
          // 登陆后请求优惠券
          if (this.userToken) this.getCouponList();
        }
      });
    },
    getCouponList() {
      api_getCouponList({
        projecttype: 1,
        projectguid: this.vipPrices[this.buyType].Month,
      })
        .then((res) => {
          if (res.data) {
            this.couponList = res.data ? res.data.nouseList || [] : [];
            if (!this.couponList.length) {
              this.configSelectedCoupon();
            } else {
              // 默认选个最大的优惠券
              this.getBestCouponSelected();
            }
            this.getTotalMoney();
          }
        })
        .catch(function() {
          this.couponList = [];
          this.configSelectedCoupon();
        });
    },
    getBestCouponSelected() {
      // 获取最好的优惠券选择
      // 规则： 1，优先选择折扣券，2. 无折扣券选择金额最大的现金券
      // 过滤出折扣券
      const dc = this.couponList.filter(function(e) {
        return e.couponType === 1;
      });
      // 过滤出当前套餐支持的现金券
      const mc = this.couponList.filter(function(e) {
        return e.couponType === 0;
      });
      if (dc.length) {
        // 有折扣券，找到折扣最大的
        let selectCoupon = dc[0];
        dc.map(function(item) {
          if (item.discount < selectCoupon.discount) {
            selectCoupon = item;
          }
        });
        this.configSelectedCoupon(selectCoupon);
      } else if (mc.length) {
        // 有现金券
        let selectCoupon = mc[0];
        mc.map(function(item) {
          if (item.money > selectCoupon.money) {
            selectCoupon = item;
          }
        });
        this.configSelectedCoupon(selectCoupon);
      } else {
        this.configSelectedCoupon();
      }
    },
    configSelectedCoupon(selectCoupon) {
      this.selectCoupon = selectCoupon;
      if (selectCoupon) {
        if (selectCoupon.couponType === 1) {
          // 折扣券
          if (selectCoupon.discount === 0) {
            this.couponText = "免单";
          } else {
            this.couponText = (selectCoupon.discount * 10).toFixed(0) + "折";
          }
        } else {
          // 现金券
          this.couponText = "-" + selectCoupon.money;
        }
      } else {
        this.couponText = "暂无优惠券可用";
      }
    },
    useCouponClick(item) {
      this.configSelectedCoupon(item);
      this.getTotalMoney();
      this.showCouponSheet = false;
    },
    dontUseCouponClick() {
      this.couponText = "不使用优惠券";
      this.selectCoupon = "";
      this.showCouponSheet = false;
      this.getTotalMoney();
    },
    showCouponSheetClick() {
      if (this.couponList.length) {
        this.showCouponSheet = true;
      }
    },
    showTipDialog(item) {
      Dialog.confirm({
        title: "使用须知",
        message: item.remark,
        showCancelButton: false,
      })
        .then(() => {})
        .catch(() => {});
    },
    buyTypeChange(index) {
      this.buyType = index;
      this.getCouponList();
    },
    getTotalMoney() {
      const price = this.vipPrices[this.buyType];
      var totalMoney = 0;
      const originalMoney = price.IsBuyedThis ? price.Money : price.FirstMoney;
      if (this.selectCoupon) {
        var couponMoney = 0;
        if (this.selectCoupon.couponType === 0) {
          // 现金券
          couponMoney = this.selectCoupon.money;
        } else {
          couponMoney = Number(
            (originalMoney * (1 - this.selectCoupon.discount)).toFixed(2)
          );
        }
        totalMoney = this.accSub(originalMoney, couponMoney);
      } else {
        totalMoney = originalMoney;
      }
      if (totalMoney < 0) totalMoney = 0;
      this.totalMoney = totalMoney;
      this.discountMoney = price.VMoney - totalMoney;
    },
    getDefaultBuyType() {
      let querySelect = -1;
      let defaultSelect = -1;
      for (let i = 0, l = this.vipPrices.length; i < l; i++) {
        if (this.vipPrices[i].Month === Number(this.$route.query.select))
          querySelect = i;
        if (this.vipPrices[i].Selected) defaultSelect = i;
      }
      if (querySelect >= 0) {
        this.buyType = querySelect;
      } else if (defaultSelect >= 0) {
        this.buyType = defaultSelect;
      } else {
        this.buyType = 0;
      }
    },
    configVipText() {
      if (
        !this.userInfo ||
        !this.userInfo.expiredTime ||
        new Date(this.userInfo.expiredTime) < new Date("2014/09/01")
      ) {
        this.vipActionText = "立即开通";
        this.vipMemo = "您还不是会员";
        return;
      }

      var days =
        (new Date(this.userInfo.expiredTime).getTime() - new Date().getTime()) /
        (24 * 60 * 60 * 1000);
      // 修复Bug: 过期1天内, floor(-0.2) 为 0, 会导致能继续使用会员功能, 故先判断 (-1, 0) 区间再 floor
      if (days > -1 && days < 0) days = -1;
      days = Math.floor(days);
      var d = Math.abs(days),
        year = Math.floor(d / 365),
        month = Math.floor((d % 365) / 30),
        day = Math.floor((d % 365) % 30),
        mess =
          (year ? +year + "年" : "") +
          (month ? month + "个月" : month && day ? "零" : "") +
          (day ? day + "天" : "");

      if (days < 0) {
        this.vipActionText = "立即支付";
        return (this.vipMemo = "会员已过期" + mess);
      } else {
        this.vipActionText = "立即支付";
        this.vipMemo =
          "到期时间：" +
          $formatDate(
            new Date(Date.parse(this.userInfo.expiredTime.replace(/-/g, "/"))),
            "yyyy-MM-dd"
          );
      }
    },
    buyVipAction() {
      if (this.userToken) {
        if (this.userInfo.schoolGuid && this.userInfo.studentName) {
          // 绑定学生的才能买
          this.actionLoading = true;
          this.$createOrder({
            source: 3,
            ordertype: 6,
            resources: this.vipPrices[this.buyType].Month,
            coupon: this.selectCoupon ? this.selectCoupon.couponCode : "",
          }).finally(() => {
            this.actionLoading = false;
          });
        } else {
          Dialog.confirm({
            title: "提示",
            message: "需要绑定学生信息才能购买",
            cancelButtonText: "暂不绑定",
            confirmButtonText: "去绑定",
          })
            .then(() => {
              this.$router.push({
                path: "/binding",
                query: encodeURIComponent("/vip"),
              });
            })
            .catch(() => {});
        }
      } else {
        this.$router.push("/login");
      }
    },
    fixedMoney(value) {
      return (parseInt(value * 10) / 10).toFixed(1);
    },
    accSub(num1, num2) {
      let r1;
      let r2;
      try {
        r1 = num1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = num2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      const m = Math.pow(100, Math.max(r1, r2));
      const n = r1 >= r2 ? r1 : r2;
      return (Math.round(num1 * m - num2 * m) / m).toFixed(n);
    },
  },
};
</script>

<style lang="scss" scoped>
.vip-container {
  padding-bottom: 50px;

  /* 会员头部 */
  .header-top {
    top: 48px;
    left: 0;
    right: 0;
    position: relative;
    height: 160px;
    background: url("../../assets/vip/header-bg.png") no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
  }

  .vip-card {
    position: absolute;
    left: 30px;
    right: 10px;
    bottom: 0;
    height: 90px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .vip-action-tip {
    background: linear-gradient(-60deg, #e85a57, #e85a57);
    color: #fff !important;
    margin-left: 10px !important;
    border: 0 !important;
    font-size: 12px !important;
    line-height: 22px !important;
    font-weight: 350;
    padding: 4px 10px 4px 10px !important;
  }

  .vip-card {
    .header {
      width: 50px;
      height: 50px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 2px solid #fbf1dc;
      }
    }

    .user {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;

      .vip-icon {
        width: 38px;
        height: 17px;
        margin-left: 5px;
      }

      .name {
        font-size: 15px;
        line-height: 15px;
        color: #926827;
        font-weight: 400;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
      }

      .time {
        font-size: 12px;
        line-height: 12px;
        color: #926827;
        margin-top: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
      }
    }
  }

  /* 支付选择 */
  .pay-type {
    padding-top: 70px;
    padding-bottom: 20px;
    font-size: 15px;
    font-weight: 500;
    background-color: #fff;

    ::v-deep .van-grid-item__content {
      padding: 0 !important;
    }
  }

  .type-item {
    display: flex;
    position: relative;
    width: 100%;
    padding-bottom: 10px;
    font-size: 14px;
    padding-top: 35px;
    border-radius: 5px;
    font-weight: 400;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
  }

  .type-selected {
    background-color: #fffbec;
    border: 2px solid #eabe71;
  }

  .type-normal {
    background-color: #ffffff;
    border: 2px solid #e8f2fb;
  }

  .item-price {
    margin-top: 5px;
    color: #926827;
    font-size: 24px;

    span {
      font-size: 15px;
      font-weight: 400;
    }
  }

  .item-old-price {
    margin-top: 5px;
    font-size: 14px;
    font-weight: 400;
    text-decoration: line-through;
  }

  .item-next-price {
    margin-top: 5px;
    font-size: 10px;
    padding: 0 5px;
    color: #ffffff;
    background-color: #e2c589;
    border-radius: 4px;
    font-weight: 300;
    white-space: nowrap;
    overflow: hidden;
  }

  .item-tip {
    position: absolute;
    left: -3px;
    top: -8px;
    color: #fff;
    padding: 2px 8px;
    background-color: #e85a57;
    font-size: 12px;
    font-weight: 300;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .intro {
    margin-top: 20px;
    padding: 0 15px;
    font-size: 15px;

    img {
      width: 100%;
      height: 100%;
    }

    .intro-title {
      margin-bottom: 10px;
    }

    .tip {
      margin-top: 10px;
      padding: 15px;
      border-radius: 5px;
      color: #433e44;
      font-size: 13px;
      line-height: 22px;
      margin-bottom: 20px;
      background-color: #f5f5f5;

      span {
        display: block;
        padding-top: 5px;
      }
    }

    .more {
      margin-top: 15px;
      font-size: 12px;
      color: #e85a57;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;
    }

    .question {
      padding: 0 15px;
      font-size: 14px;
      line-height: 25px;
      margin-bottom: 10px;
      color: #666;

      h6 {
        color: #d29b4b;
        font-weight: 400;
        font-size: 16px;
        line-height: 30px;
        margin: 0;
        padding-bottom: 5px;
      }
    }

    .protocol {
      padding: 10px 0;
      margin-left: 15px;
      font-size: 14px;
      display: flex;
      align-items: center;

      a {
        text-decoration: none;
      }

      img {
        width: 15px;
      }
    }
  }

  .protos a {
    display: block;
    padding: 10px 15px;
    font-size: 14px;
    line-height: 25px;
  }

  .footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("../../assets/vip/footer-bg.png") no-repeat center;
    background-size: 100% 100%;
    height: 60px;
    display: flex;
    flex-direction: row;
    padding: 0 10px;
    align-items: center;
    justify-content: space-between;

    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .price {
        font-size: 18px;
        font-weight: 400;

        span {
          font-size: 13px;
          font-weight: 300;
        }
      }

      .proto {
        font-size: 10px;
        font-weight: 300;
      }
    }
  }

  .footer-height {
    height: 10px;
  }

  .buy-btn {
    margin: 0 auto;
    background-color: transparent;
    font-size: 15px;
    color: #fff !important;
    text-align: center;
    border: 0;
    background: transparent;
  }

  .line {
    height: 10px;
    background-color: #f7f7f7;
  }

  .sheet-content {
    min-height: 250px;
    max-height: 450px;
    overflow-y: auto;

    .coupon-item {
      background: url("../../assets/vip/coupin.png") no-repeat center;
      background-size: 100% 100%;
      height: 150px;
      padding: 20px 25px;
      display: flex;
      flex-direction: column;

      .content {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;

        .price {
          display: flex;
          flex-direction: row;
          align-items: flex-end;
          justify-content: flex-end;
          font-size: 40px;
          line-height: 40px;
          color: #e85a57;

          span {
            font-size: 15px;
            line-height: 15px;
            color: #e85a57;
            padding-bottom: 5px;
            padding-left: 5px;
          }
        }

        .desc {
          display: flex;
          flex: 1;
          flex-direction: column;
          font-size: 15px;
          margin-left: 20px;

          .time {
            font-size: 15px;
            font-weight: 300;
          }
        }
      }

      .tip {
        height: 35px;
        display: flex;
        flex-direction: row;
        align-items: center;

        label {
          font-size: 15px;
          line-height: 15px;
          color: #aaaaaa;
          margin-left: 5px;
        }
      }
    }
  }

  .dont-use {
    font-size: 15px;
    padding: 15px 15px;
    margin: 0 15px;
    margin-bottom: 20px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
  }

  .coupon {
    ::v-deep .van-cell__value {
      color: #e85a57;
    }
  }
}
</style>
